import type { FederationRuntimePlugin } from '@module-federation/enhanced/runtime';
import { StaticMetricsPlugin } from '@vk-tech-solar/module-federation-runtime-plugins';
import axios from 'axios';

const metricsRuntimePlugin = (): FederationRuntimePlugin =>
  StaticMetricsPlugin({
    onMetrics: metrics => {
      if (window.location.hostname.startsWith('local.') || false) {
        return;
      }
      const event = Object.entries(metrics).reduce(
        (result: Record<string, string>, [key, value]) => {
          if (!value) {
            return result;
          }
          result[key] = String(value);
          return result;
        },
        {},
      );

      axios
        .post(
          '/infra/dpp',
          {
            timestamp: new Date(metrics.end).toISOString(),
            event_type: 'mcs:front:static:metrics',
            event: {
              ...event,
              env: 'kz_prod',
            },
          },
          { timeout: 3000 },
        )
        .catch(() => {});
    },
  });

export default metricsRuntimePlugin;
